import { Button, Input } from '@platform/design-system';
import { useState, type InputHTMLAttributes } from 'react';
import styles from './SearchField.module.css';

export type SearchFieldProps = {
  label: string;
  buttonLabel: string;
  errorText?: string | undefined;
  inputMode?: InputHTMLAttributes<HTMLInputElement>['inputMode'];
  type?: 'search' | 'tel';
  clearSignal?: number;
  onSearch: (term: string | null) => void;
};

const ENTER = 'Enter';

export const SearchField = ({
  label,
  buttonLabel,
  errorText,
  inputMode,
  type = 'search',
  clearSignal = 0,
  onSearch,
}: SearchFieldProps) => {
  const [draft, setDraft] = useState('');
  const [clearedAt, setClearedAt] = useState(clearSignal);
  if (clearedAt !== clearSignal) {
    setClearedAt(clearSignal);
    setDraft('');
  }
  const search = () => {
    onSearch(draft.trim() === '' ? null : draft.trim());
  };
  return (
    <div className={styles['search']} role="search">
      <Input
        label={label}
        type={type}
        inputMode={inputMode}
        dir={type === 'tel' ? 'ltr' : undefined}
        autoComplete="off"
        errorText={errorText}
        value={draft}
        onChange={(event) => {
          setDraft(event.target.value);
        }}
        onKeyDown={(event) => {
          if (event.key !== ENTER) return;
          event.preventDefault();
          search();
        }}
      />
      <Button type="button" variant="outline" onClick={search}>
        {buttonLabel}
      </Button>
    </div>
  );
};
